<template>
    <div class="app">
        <!--面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>软件升级包管理</el-breadcrumb-item>
            <el-breadcrumb-item>APP版本</el-breadcrumb-item>
        </el-breadcrumb>
        <!--卡片视图区域-->
        <el-card class="el-card">
            <el-row :gutter="20">
                <!--搜索与添加区域-->
                <el-col :span="4">
                    <el-input placeholder="请输入版本号" v-model="queryInfo.inputName" clearable @clear="getAppEditionList">
                    </el-input>
                </el-col>
                <!--搜索按钮-->
                <el-col :span="3">
                    <el-button type="primary" icon="el-icon-search" @click="getAppEditionList">{{$t('common.search')}}</el-button>
                </el-col>

                <el-col :span="2" style="float: right">
                    <el-button type="primary" icon="el-icon-plus" @click="openAppEditionInfo">{{$t('common.add')}}</el-button>
                </el-col>
            </el-row>
            <!--记录区域-->
            <el-table :data="addAppEditionList.records" border stripe style="width: 100%" v-loading="loading">
                <el-table-column label="版本号" prop="versions" align="center"></el-table-column>
                <el-table-column label="APP类型" prop="type" align="center"></el-table-column>
                <el-table-column label="描述" prop="descb" align="center"></el-table-column>
                <el-table-column label="文件地址" prop="versionsUrl" align="center"></el-table-column>
                <el-table-column label="是否强制更新" sortable prop="isForce" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isForce == 1" type="success">强制</el-tag>
                        <el-tag v-else type="danger">不强制</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" sortable prop="creationTime" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <!--删除-->
                        <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                            <el-button type="danger" icon="el-icon-delete" size="mini"
                                       @click="removeAppEditionById(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <!--分页区域-->
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryInfo.pageNum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="queryInfo.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="addAppEditionList.total">
            </el-pagination>
        </el-card>

        <!--        添加数据弹框-->
        <el-dialog
                title="增加APP软件包"
                :visible.sync="addDialogVisible"
                width="700px">
            <el-form :model="addAppEdition" label-width="100px" :inline="true">
                <el-form-item label="版本号" prop="versions">
                    <el-input v-model="addAppEdition.versions" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="APP类型" prop="type">
                    <el-select v-model="addAppEdition.type" placeholder="请选择硬件类型" style="width: 500px">
                        <el-option
                                v-for="item in options1"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="版本描述" prop="descb">
                    <el-input type="textarea" :rows="4" v-model="addAppEdition.descb" style="width: 500px"></el-input>
                </el-form-item>
                <el-form-item label="是否强制更新" prop="isForce" style="width: 500px">
                    <el-radio-group v-model="addAppEdition.isForce">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="0">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <!--<el-form-item label="创建时间" prop="creationTime">-->
                    <!--<el-date-picker-->
                            <!--v-model="addAppEdition.creationTime"-->
                            <!--type="datetime"-->
                            <!--value-format="yyyy-MM-dd HH:mm:ss"-->
                            <!--placeholder="选择日期时间" style="width: 500px">-->
                    <!--</el-date-picker>-->
                <!--</el-form-item>-->
                <el-form-item label="上传文件" style="height: 100px">
                    <el-upload
                            :action="baseUrl"
                            :limit="1"
                            :show-file-list="true"
                            :on-success="handleUploadSuccess"
                            :on-exceed="handleExceed"
                            :file-list="fileList">
                        <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAppEditionInfo">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AppEditionList",
        data() {
            return {
                options1: [
                    {
                        value: '糖分检测APP',
                        label: '糖分检测APP'
                    }
                ],
                baseUrl: "http://brix.zhengtusensor.com:8888/zhengtusensor/upload/AppEdition",
                fileList:[],
                addAppEdition:{
                    isForce:1
                },
                addDialogVisible: false,
                loading: false,
                queryInfo: {
                    pageNum: 1,
                    pageSize: 10
                },
                addAppEditionList: {
                    records: [],
                    total: 0
                },
            }
        },
        created() {
            this.getAppEditionList();
        },
        methods: {
            handleUploadSuccess(response, file, fileList) {
                this.fileList = fileList
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            async addAppEditionInfo(){
                let ip = "http://brix.zhengtusensor.com:8888";
                let params = {};
                console.log(this.fileList)
                if (this.addAppEdition.versions == "" || this.addAppEdition.versions == undefined) {
                    this.$message.error("请输入版本号")
                    return
                }
                if (this.addAppEdition.descb == "" || this.addAppEdition.descb == undefined) {
                    this.$message.error("请输入版本描述")
                    return
                }
                // if (this.addAppEdition.creationTime == "" || this.addAppEdition.creationTime == undefined) {
                //     this.$message.error("请输入创建时间")
                //     return
                // }
                if (this.fileList.length == 0) {
                    this.$message.error("请上传版本文件")
                    return
                }
                params = this.addAppEdition;
                params.versionsUrl = ip + this.fileList[0].response.data;
                let {data: res} = await this.$http.post(`/appedition/addAppEdition`, params);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.addDialogVisible = false;
                this.getAppEditionList()
            },
            openAppEditionInfo(){
                this.fileList = []
                this.addAppEdition = { isForce: 1}
                this.addDialogVisible = true
            },
            // 获取记录列表
            async getAppEditionList() {
                this.loading = true
                let {data: res} = await this.$http.post(`/appedition/selectPage`, this.queryInfo);
                if (res.code !== 1) return this.$message.error(res.msg);
                this.addAppEditionList.records = res.data.records;
                this.addAppEditionList.total = res.data.total;
                this.loading = false
            },
            // 监听pageSize改变的事件
            handleSizeChange(newSize) {
                this.queryInfo.pageSize = newSize;
                this.getAppEditionList()
            },
            // 监听pageNum改变的事件
            handleCurrentChange(newPage) {
                this.queryInfo.pageNum = newPage;
                this.getAppEditionList()
            },
            // 根据id删除记录信息
            async removeAppEditionById(item) {
                let params = item;
                // 弹框询问用户是否删除记录
                await this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    // 删除记录
                    const {data: res} = await this.$http.post(`/appedition/deleteById`, params);
                    if (res.code !== 1) return this.$message.error("删除失败");
                    this.$message.success("删除成功");
                    // 重新获取记录列表
                    this.getAppEditionList();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
        }
    }
</script>

<style lang="less" scoped>
    .el-table {
        margin-top: 15px;
        font-size: 12px;
    }

    .el-pagination {
        margin-top: 15px;
    }

    .app .el-card {
        width: 99%;
    }
</style>
